import styles from "./toast.module.scss";
import ToastItem from "./components/toast-item/ToastItem.jsx";
import { useToastStore } from "@/state/toasts/toast-store";

const Toast = ({ storeRef = useToastStore }) => {
  const toasts = storeRef((state) => state.toasts);
  return (
    <div className={`${styles.toast} flex column row-gap-2`}>
      {toasts.reverse().map((toast) => (
        <ToastItem key={toast.id} storeRef={storeRef} {...toast} />
      ))}
    </div>
  );
};

export default Toast;
